import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React, { useContext } from "react";
import { deleteRoles, deleteUser } from "../../services";
import { notify } from "../actions/CommonActions";

export const DeleteUserModal = ({
  show,
  toggle,
  handleChangePassword,
  isChanging,
  user,
  refetch,
  setIsChanging
}) => {
  // console.log('new role ',role);

  const DeleteUserCall = async (user) => {
    setIsChanging(true);
    // e.preventDefault();
    await deleteUser(user?.id, user?.name)
      .then((res) => {
        notify("success", "User Deleted.", res?.message);
        // setShowUser(false);
        setIsChanging(false);
        toggle()
        refetch();
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message);
        setIsChanging(false);
      });
  };


  return (
    <Modal
      centered
      show={show}
      onHide={toggle}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        {/* <div> */}
        <Modal.Title>Delete User</Modal.Title>
        {/* </div> */}
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to proceed? Proceeding will delete the user.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{
            backgroundColor: "#007dcc",
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
          onClick={(e) => {
            e.preventDefault();
            DeleteUserCall(user);
          }}
          disabled={isChanging}
        >
          {isChanging ? "Loading..." : "Delete"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
